import { useCallback, useEffect, useState } from 'react';
import { Col, Row, Table } from 'reactstrap';
import { ContentBlock } from '../Shared/Content/ContentBlock';
import { ContentBody } from '../Shared/Content/ContentBody';
import { ContentHeading } from '../Shared/Content/ContentHeading';
import { clientConfig } from '../../utilities/configService';
import { useFetchWrapper } from '../../hooks/useFetchWrapper';
import { FundingSourceCard } from '../Resources/FundingSources/FundingSourceCard';
import { IFundingSource } from '../Resources/FundingSources/FundingSources';

interface IProps {
    sectionTitle: string,
    sectionDescription: string
}

interface IFundingSourceCatalogResponse {
    success: boolean;
    message?: string;
    fundingSources: IFundingSource[];
}

export const ExampleFundingSources = ({ sectionTitle, sectionDescription }: IProps) => {
    const fetchWrapper = useFetchWrapper();

    const [fundingSourcesData, setFundingSourcesData] = useState<IFundingSource[]>([]);
    const applicationName = clientConfig?.APPLICATION_NAME || '';

    const getFundingSourcesSamples = useCallback(() => {
        fetchWrapper.get(`funding/getsamplesbyapplication/${applicationName}`)
            .then((data: IFundingSourceCatalogResponse) => {
                if (data.success && data.fundingSources) {
                    setFundingSourcesData(data.fundingSources);
                }
            });
    }, [applicationName]);

    useEffect(() => {
        getFundingSourcesSamples();
    }, [getFundingSourcesSamples]);

    return (
        <>
            {fundingSourcesData.length > 0 ? (
                <ContentBlock className="exampleFundingSources">
                    <ContentHeading title={sectionTitle} />
                    <ContentBody>
                        <div className="heading5" dangerouslySetInnerHTML={{ __html: sectionDescription }}></div>
                        <div className="exampleFundingSourcesTables">
                            <Row>
                                {fundingSourcesData.map((item: IFundingSource, index: number) => {
                                    return (
                                        <Col sm={12} className="detailCol" key={index}>
                                            <FundingSourceCard fundingSourceItem={item} />
                                        </Col>
                                    );
                                })}
                            </Row>
                        </div>
                    </ContentBody>
                </ContentBlock>
            ) : (
                <></>
            )}
        </>
    );
};
